import { IEventTracking } from 'common/interface/services';

export class EventTracking implements IEventTracking {
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    track(eventName: string, properties?: { [params: string]: string | number | boolean | undefined }): void {}
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    pageView(): void {}
}
